import { ReactElement, useCallback, useState } from 'react';
import { OptimizedImage } from '@cars4ever/media-utils';

import ICarColor from '^types/ICarColor';
import ColorOption from '^components/common/ColorChooser/ColorOption';
import { emitChangeColorClick } from '^utils/gtmEvents';

import styles from './styles.module.scss';

interface IColorChooserProps {
  colors: ICarColor[];
}

const ColorChooser = ({ colors }: IColorChooserProps): ReactElement => {
  const [activeColor, setActiveColor] = useState<ICarColor>(colors[0]);

  const handleSelect = useCallback(
    (color: ICarColor): void => {
      setActiveColor(color);
      emitChangeColorClick(color.imageToken);
    },
    [setActiveColor],
  );

  return (
    <div>
      <OptimizedImage
        publicId={activeColor?.imageToken}
        className={styles.mainImage}
      />

      <div className={styles.optionsContainer}>
        {colors.map((color: ICarColor): ReactElement => (
          <ColorOption
            key={color.imageToken}
            onSelect={handleSelect}
            isSelected={color.iconToken === activeColor.iconToken}
            color={color}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorChooser;
